import initialState from './initialState';
import { reducer as getConversationsReducer } from './getConversations';
import { reducer as clearConversationHistoryReducer } from './clearConversationHistory';
import { reducer as generateVibeResponseReducer } from './generateVibeResponse';
import { reducer as getConversationHistoryReducer } from './getConversationHistory';
import { reducer as workspaceReducer } from './workspace';
import { reducer as workspacePreviewReducer } from './workspacePreview';
import { reducer as planReducer } from './plan';
import { reducer as workspaceFileReducer } from './workspaceFile';
const reducers = [
  getConversationsReducer,
  clearConversationHistoryReducer,
  generateVibeResponseReducer,
  getConversationHistoryReducer,
  workspaceReducer,
  workspacePreviewReducer,
  planReducer,
  workspaceFileReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
